import { formatIncompletePhoneNumber } from 'libphonenumber-js/min';

export function formatPhoneNumberInput(value: string) {
  return formatIncompletePhoneNumber(value, 'US');
}
